export const paretoPage = 'tid-pareto-page';
export const paretoChart = 'tid-pareto-chart';
export const paretoNoData = 'tid-no-data';
export const paretoLegend = 'tid-legend';
